import { StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { borderRadius3, borderWidth1, colorBorderInputError, colorBorderInputFocus, colorBorderInteractive, colorIcon, colorIconError, colorIconLight, colorText, colorTextError, colorTextMedium, fontInputPaddingRight, iconSize, inputSize, space05, space1, space4, space6, } = theme();
    const styles = StyleSheet.create({
        error: {
            marginTop: space1,
        },
        hint: {
            marginTop: space1,
        },
        icon: {
            position: "absolute",
            right: fontInputPaddingRight,
            top: space4 - space05,
            zIndex: 4,
        },
        inputContainer: {
            alignItems: "center",
            borderRadius: borderRadius3,
            borderWidth: borderWidth1,
            flexDirection: "row",
            height: inputSize,
        },
    });
    return {
        ...styles,
        inputPaddingRightWithIcon: iconSize + space6,
        colorBorderInputError,
        colorBorderInputFocus,
        colorBorderInteractive,
        colorText,
        colorTextMedium,
        colorTextError,
        colorIcon,
        colorIconError,
        colorIconLight,
    };
};
export { style };
